import { consoleInfo } from '@wilson/non-domain-specific/logger/logger';
import { RealtimeServerEvent } from './realtime.types';

export function handleRealtimeServerEventSafely({
  event,
  handler,
  context,
}: {
  event: RealtimeServerEvent;
  handler: (event: RealtimeServerEvent) => void;
  context: string;
}): void {
  try {
    handler(event);
  } catch (error) {
    consoleInfo(
      `[Realtime] Dropped event after handler error (${context}): ${String(error)}`,
    );
  }
}
